/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2017 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/

import React from 'react'
import PropTypes from 'prop-types'

class FileType extends React.Component {
  render () {
    return (
      <div className='item'>
        <div>
          <span className={'fa fa-' + this.props.styling + ' fa-2x'} aria-hidden='true' />
          <a href='#'>{this.props.title}</a>
        </div>
        <a href='#'><i className='fa fa-trash-o' aria-hidden='true' /></a>
      </div>

    )
  }
}

FileType.propTypes = {
  styling : PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default FileType
